module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"reference-point":"Ponto de referência"},"en-US":{"reference-point":"Reference point"}}')
  delete Component.options._Ctor
}
